import React from "react";
import { X } from "lucide-react";

export default function Modal({ title, icon: Icon, onClose, children, maxWidth = "max-w-md" }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-xs" onClick={onClose}>
      <div
        className={`bg-white dark:bg-[#303134] rounded-3xl ${maxWidth} w-full p-6 shadow-2xl border border-[#dadce0] dark:border-[#3c4043] animate-pop-in max-h-[90vh] overflow-y-auto`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between pb-4 border-b border-[#e8eaed] dark:border-[#3c4043]">
          <div className="flex items-center gap-2">
            {Icon && (
              <div className="p-2 rounded-xl bg-[#e8f0fe] dark:bg-[#1a2e4c] text-[#1a73e8]">
                <Icon className="w-5 h-5" />
              </div>
            )}
            <h3 className="text-lg font-semibold text-[#202124] dark:text-[#e8eaed]">{title}</h3>
          </div>
          <button onClick={onClose} className="w-8 h-8 rounded-full flex items-center justify-center text-[#5f6368] hover:bg-[#f1f3f4] dark:hover:bg-[#202124] cursor-pointer">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="mt-4">{children}</div>
      </div>
    </div>
  );
}
